import { useEffect, useRef, useState } from "react";
import styles from "./LandingAmbient.module.css";

export function LandingAmbient({ variant = "light" }) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  const [visible, setVisible] = useState(!document.hidden);
  useEffect(() => {
    const onVisibility = () => setVisible(!document.hidden);
    const observer = typeof IntersectionObserver === "function" ? new IntersectionObserver(([entry]) => {
      setInView(entry.isIntersecting);
    }) : null;
    if (ref.current) observer?.observe(ref.current);
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      observer?.disconnect();
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);
  const hero = variant === "hero";
  return <div ref={ref} className={`${styles.layer}${hero ? ` ${styles.hero}` : ""}`} aria-hidden="true" data-testid={hero ? "hero-ambient" : "landing-ambient"} data-running={inView && visible}>
    <div className={styles.viewport}>
      <div className={`${styles.orb} ${styles.primary}`} />
      <div className={`${styles.orb} ${styles.secondary}`} />
      <div className={`${styles.orb} ${styles.tertiary}`} />
      <div className={styles.vignette} />
    </div>
  </div>;
}
